<template>
  <div 
    class="searchresults"
  >
    <Herosearch 
      :autofocus="true" 
    />
<v-list 
  two-line
>
      <template 
        v-for="(item, index) in items"
      >
         <Searchresult 
          :title="item.title" 
          :subtitle="item.subtitle" 
          :key="index"
        />
      </template>
</v-list>

   
  </div>
</template>

<script>
// // @ is an alias to /src
import Searchresult from '@/components/Searchresult.vue'
import Herosearch from '@/components/Herosearch.vue'

export default {
  name: 'Searchresults',
  components: {
      Searchresult,
      Herosearch,

  },
  data: () => ({
      items: [
        {
 
          title: 'Sushi palace',
          subtitle: "10 rue des Platanes",
        },
        {
       
          title: 'Summer BBQ',
          subtitle: "5 allée des tulipes",
        },
        {
       
          title: 'Burger plaza',
          subtitle: "12 place de la maire",
        },
        {
         
          title: 'Pizzeria',
          subtitle: "11 avenue des arbres",
        },
      ],
    }),
}
</script>

<style scoped>
.Searchresult{

margin: auto;
}
</style>

